import React from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import DistancesAndElevationForm from '../Forms/DistancesAndElevationForm';

const DistancesAndElevationModal = ({
    isOpen,
    isEdit,
    handleToggleModal,
    dataDistanceElevation,
    handleSave,
    waterRightId,
    intakeCoordinatesList = [],
    restitutionCoordinatesList = [],
}) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={handleToggleModal}
            size='md'
            className='border-0'
            modalClassName='modal fade zoomIn'
            backdrop={'static'}
            centered={true}
            unmountOnClose={true}
        >
            <ModalHeader toggle={handleToggleModal}>
                {isEdit ? 'Editar' : 'Agregar'} Distancia y Desnivel
            </ModalHeader>

            <DistancesAndElevationForm
                dataDistanceElevation={dataDistanceElevation}
                isOpen={isOpen}
                isEdit={isEdit}
                handleToggleModal={handleToggleModal}
                handleSave={handleSave}
                waterRightId={waterRightId}
                intakeCoordinatesList={intakeCoordinatesList}
                restitutionCoordinatesList={restitutionCoordinatesList}
            />
        </Modal>
    );
};

export default DistancesAndElevationModal;